import p from '../../../theme/palette';

export const styles = {
  mapImage: {
    backgroundColor: p.avatarDefaultBg,
    color: p.avatarDefaultColor,
    borderColor: p.avatarDefaultBorder,
  },
};
